export const advs = [
{
    img: './Imageadv/adv1.png', 
    subtitle: 'Огромное количество практики', 
    text: 'Более 500 самостоятельных заданий и 20 полноценных больших проектов'
},
{ 
    img: './Imageadv/adv2.png', 
    subtitle: 'Современные методики обучения', 
    text: 'Спиральное обучение:погружаемся в материал постепенно, виток за витком'
},
{ 
    img: './Imageadv/adv3.png', 
    subtitle: 'Простое и понятное изложение', 
    text: 'Вместо заумных терминов – примеры из реального мира'
},
{ 
    img: './Imageadv/adv4.png', 
    subtitle: 'Гибкий график занятий', 
    text: 'Учитесь в любое время в удобном для вас темпе'
},
{  
    img: './Imageadv/adv5.png', 
    subtitle: 'Прямая связь с опытными программистами', 
    text: 'Задавайте вопросы и отправляйте свой код на проверку'
},
{ 
    img: './Imageadv/adv6.png', 
    subtitle: 'Оплата небольшими частями', 
    text: 'Платите только за тот материал, который сейчас изучаете,а не за весь курс сразу'
},
{ 
    img: './Imageadv/adv7.png', 
    subtitle: 'Быстрый и легкий возврат', 
    text: 'Если передумаете учиться – вернем деньги за 3 рабочих дня'
}
];
